<template>
    <div>
      <g-card :temCabecalho="false" :expansivel="false">
      <div class="header-detalhes-secundario">
        <div class="header-detalhes-secundario-titulo">
            <g-button
            class="buscar-button-header"
            largura="35px"
            icone="icone_voltar.svg"
            negritoTexto
            tamanhoIcone="10px"
            cor="#FFFFFF"
            altura="30px"
            :sombreado="false"
            @click="voltar()"
            />

          <div class="titulo-detalhes-cabecalho"> Nota Fiscal Itens</div>
        </div>

        <div class="header-icons">
          <g-button
            class="botoes"
            altura="35px"
            largura="35px"
            tamanhoIcone="15px"
            icone="icone_print.svg"
            v-tooltip="'Abrir PDF'"
            @click="abrirPDF()"
          >
          </g-button>

          <g-button
            altura="35px"
            largura="35px"
            tamanhoIcone="18px"
            class="button-compartilhar-copia"
            icone="pi pi-download"
            corIconeClass="4f2c19"
            @click="baixarPDF"
            v-tooltip="'Baixar PDF'"
          >
          </g-button>
        </div>
      </div>

      <div class="conteudo-card-itens-notas-fiscais espacamento-detalhes">
        <div class="titulo-grupo-detalhes">{{ this.notaFiscalCodigoExterno }} </div>
        <div class="grupo-repeticao-parcelas" v-for="(obj, index) in this.itensNotasFiscaisArray" :key="index">
        <div class="grupo-sequencia">Sequência {{ obj.sequencia }}</div>
        <div class="itens-container">

          <div class="item-grid">
            <div class="titulo-conteudo-detalhes">Item</div>
            <div class="label-conteudo"> {{ obj.codigoProduto }}	- {{ obj.nomeItem }} </div>
          </div>

          <div class="unidade-medida-grid">
            <div class="titulo-conteudo-detalhes">Unid. Medida</div>
            <div class="label-conteudo"> {{ obj.codigoUnidadeMedida }} </div>
          </div>

          <div class="peso-grid">
            <div class="titulo-conteudo-detalhes">Peso</div>
            <div class="label-conteudo"> {{ obj.pesoUnitario }} </div>
          </div>

          <div class="qtde-grid">
            <div class="titulo-conteudo-detalhes">Qtde</div>
            <div class="label-conteudo"> {{ obj.quantidadeItem }} </div>
          </div>

          <div class="desconto-mestre-grid">
            <div class="titulo-conteudo-detalhes">% desc. mestre</div>
            <div class="label-conteudo"> {{ obj.percentualDescontoAdicionalMestre }}% </div>
          </div>

          <div class="porcentagem-desconto-grid">
            <div class="titulo-conteudo-detalhes">% desc.</div>
            <div class="label-conteudo"> {{ obj.percentualDescontoAdicional }}% </div>
          </div>

          <div class="desconto-grid">
            <div class="titulo-conteudo-detalhes">Desconto</div>
            <div class="label-conteudo"> {{ obj.valorTotalDescontoAdicional }} </div>
          </div>

          <div class="monstagem-grid">
            <div class="titulo-conteudo-detalhes">Montagem</div>
            <div class="label-conteudo"> {{ obj.numeroOrdemDeCompra }} </div>
          </div>

          <div class="preco-pedido-grid">
            <div class="titulo-conteudo-detalhes">Preço Pedido</div>
            <div class="label-conteudo"> {{ obj.precoUnitarioNotaFiscalFormatado }} </div>
          </div>

          <div class="preco-nota-grid">
            <div class="titulo-conteudo-detalhes">Preço Nota</div>
            <div class="label-conteudo"> {{ obj.precoUnitarioNotaFiscalFormatado }} </div>
          </div>

          <div class="porcentagem-ipi-grid">
            <div class="titulo-conteudo-detalhes">% IPI</div>
            <div class="label-conteudo"> {{ obj.percentualIPI }}% </div>
          </div>

          <div class="ipi-grid">
            <div class="titulo-conteudo-detalhes">IPI</div>
            <div class="label-conteudo"> {{ obj.valorIPIFormatado }} </div>
          </div>

          <div class="val-liquido-grid">
            <div class="titulo-conteudo-detalhes">Val. Líquido</div>
            <div class="label-conteudo"> {{ obj.valorTotalLiquidoItemFormatado }}</div>
          </div>

          <div class="pedido-parc-grid">
            <div class="titulo-conteudo-detalhes">Pedido/Parc.</div>
            <div class="label-conteudo"> {{ obj.pedidoParcela}}</div>
          </div>
        </div>
      </div>
    </div>

      </g-card>
    </div>

    <g-pdf :fazDownload="podeBaixarPdf ? true : false" :downloadAoAbrir="true" :pdfFloat="false" :NovaGuia="abrePdf ? true : false" :executar="executarvisualizacao" :nomeArquivo="`Itens_NFE_${serieNotaFiscal}_${notaFiscalCodigoExterno}`">
      <div class="render" v-if="renderiza">
        <PDFItensNotaFiscal 
          v-on:termino="gerarPdf" 
          :notaFiscal="NotaFiscalId" 
        /> 
      </div>
    </g-pdf>
  </template>

  <script>
  import ItensNotasFiscais from './ItensNotasFiscais.js'
  export default ItensNotasFiscais
  </script>

  <style scoped>

    .header-titulo-voltar {
      width: 100%;
      display: flex;
      align-items: flex-end;
    }

    .titulo {
      color: #3e3e3e;
      text-align: left;
      font-family: "MontSerrat";
      font-weight: 500;
      margin-top: 15px;
    }

    .conteudo {
      color: #8a8a8a;
      text-align: left;
      font-family: "MontSerrat";
      margin-bottom: 10px;
    }

    .card-titulo-itens-notas {
      color: #4f2c19;
      font-weight: bold;
      font-size: 1.1rem;
    }

    .agrupa-divs{
    display: flex;
    justify-content: space-between;
    grid-area: 1 / 1 / 2/ 7;
    }

   .grupo-sequencia
   {
      margin-top: 30px;
      display: flex;
      text-align: left;
      color: #4f2c19;
      font-weight: bold;
      font-size: 1.1rem;
   }


    @media (min-width:310px) {
      .header-itens-notas-fiscais {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid #f0f0f0;
      }
      .itens-container {
        display: grid;
        grid-template-columns: repeat(1, minmax(4em, 1fr));
        grid-template-rows: repeat(14, auto);
        column-gap: 3%;
        border-bottom: 1px solid #f0f0f0;
      }
    }


    @media (min-width:368px) {
      .header-itens-notas-fiscais {
          grid-template-columns: 25% repeat(2, auto);
      }
      .itens-container {
        display: grid;
        grid-template-columns: repeat(2, minmax(4em, 1fr));
        grid-template-rows: repeat(7, auto);
        column-gap: 3%;
      }
    }


    @media (min-width:600px) {
      .header-itens-notas-fiscais {
          padding: 20px 0 10px;
      }
      .itens-container {
        display: grid;
        grid-template-columns: repeat(4, minmax(4em, 1fr));
        grid-template-rows: repeat(4, auto);
        column-gap: 3%;
      }
      .item-grid{grid-area: 1 / 1 / 2 / 3;}
      .unidade-medida-grid{grid-area: 1 / 3 / 2 / 4;}
      .peso-grid{grid-area: 1 / 4 / 2 / 5;}
      .qtde-grid{grid-area: 2 / 1 / 3 / 2;}
      .desconto-mestre-grid{grid-area: 2 / 2 / 3 / 3;}
      .porcentagem-desconto-grid{grid-area: 2 / 3 / 3 / 4;}
      .desconto-grid{grid-area: 2 / 4 / 3 / 5;}
      .monstagem-grid{grid-area: 3 / 1 / 4 / 2;}
      .preco-pedido-grid{grid-area: 3 / 2 / 4 / 3;}
      .preco-nota-grid{grid-area: 3 / 3 / 4 / 4;}
      .porcentagem-ipi-grid{grid-area: 3 / 4 / 4 / 5;}
      .ipi-grid{grid-area: 4 / 1 / 5 / 2;}
      .val-liquido-grid{grid-area: 4 / 2 / 5 / 3;}
      .pedido-parc-grid{grid-area: 4 / 3 / 5 / 4;}
    }


    @media (min-width:801px) {
      .conteudo-card-itens-notas-fiscais {
        padding: 0 30px;
      }

      .itens-container {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-template-rows: repeat(2, 1fr);
        row-gap: 1rem;
      }

      .item-grid{grid-area: 1 / 1 / 2 / 3;}
      .unidade-medida-grid{grid-area: 1 / 3 / 2 / 4;}
      .peso-grid{grid-area: 1 / 4 / 2 / 5;}
      .qtde-grid{grid-area: 1 / 5 / 2 / 6;}
      .desconto-mestre-grid{grid-area: 2 / 1 / 3 / 2;}
      .porcentagem-desconto-grid{grid-area: 2 / 2 / 3 / 3;}
      .desconto-grid{grid-area: 2 / 3 / 3 / 4;}
      .monstagem-grid{grid-area: 2 / 4 / 3 / 5;}
      .preco-pedido-grid{grid-area: 2 / 5 / 3 / 6;}
      .preco-nota-grid{grid-area: 3 / 1 / 4 / 2;}
      .porcentagem-ipi-grid{grid-area: 3 / 2 / 4 / 3;}
      .ipi-grid{grid-area: 3 / 3 / 4 / 4;}
      .val-liquido-grid{grid-area: 3 / 4 / 4 / 5;}
      .pedido-parc-grid{grid-area: 3 / 5 / 4 / 6;}
    }


    @media (min-width:1025px) {
      .itens-container {
        display: grid;
        grid-template-columns: repeat(6, minmax(4em, 1fr));
        grid-template-rows: repeat(1, auto);
        column-gap: 3%;
      }

      .item-grid{grid-area: 1 / 1 / 2 / 3;}
      .unidade-medida-grid{grid-area: 1 / 3 / 2 / 4;}
      .peso-grid{grid-area: 1 / 4 / 2 / 5;}
      .qtde-grid{grid-area: 1 / 5 / 2 / 6;}
      .desconto-mestre-grid{grid-area: 1 / 6 / 2 / 7;}
      .porcentagem-desconto-grid{grid-area: 2 / 1 / 3 / 2;}
      .desconto-grid{grid-area: 2 / 2 / 3 / 3;}
      .monstagem-grid{grid-area: 2 / 3 / 3 / 4;}
      .preco-pedido-grid{grid-area: 2 / 4 / 3 / 5;}
      .preco-nota-grid{grid-area: 2 / 5 / 3 / 6;}
      .porcentagem-ipi-grid{grid-area: 2 / 6 / 3 / 7;}
      .ipi-grid{grid-area: 3 / 1 / 4 / 2;}
      .val-liquido-grid{grid-area: 3 / 2 / 4 / 3;}
      .pedido-parc-grid{grid-area: 3 / 3 / 4 / 4;}


    .conteudo-card-itens-notas-fiscais {
        padding: 0 50px;
      }
    }


    @media (min-width:1281px) {
      .itens-container {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 5%;
      }
    }

    @media (min-width: 1500px){
      .itens-container {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 5%;
      }
    }

  </style>
